import { DripCustomEvent, DripStandardEvents } from '@xyo-network/sdk-xyo-react-js';
class DripEvents extends DripStandardEvents {
    testStarted() {
        return new DripCustomEvent('TestStarted');
    }
    emailCollected() {
        return new DripCustomEvent('EmailCollected');
    }
    accountCreated() {
        return new DripCustomEvent('AccountCreated');
    }
    shareCompleted() {
        return new DripCustomEvent('ShareCompleted');
    }
    installCompleted() {
        return new DripCustomEvent('InstallCompleted');
    }
    funnelCompleted() {
        return new DripCustomEvent('FunnelCompleted');
    }
    trialStarted() {
        return new DripCustomEvent('TrialStarted');
    }
    funnelStarted() {
        return new DripCustomEvent('FunnelStarted');
    }
    userClick() {
        return new DripCustomEvent('UserClick');
    }
    purchase() {
        return new DripCustomEvent('track', 'F+S Purchase');
    }
}
export default DripEvents;
//# sourceMappingURL=index.js.map